import { api } from "../api";

/**
 * secretariesFindAllExportResponse - Function that finds on database all secretaries by status and export in a PDF/XSLX file  
 * /secretaries/{customerId}/${status}/${exportType}/export  
 * method GET  
 * @async-function
 */
const secretariesFindAllExportResponse = async (token: string, customerId: number, status: string, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/secretaries/${customerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default secretariesFindAllExportResponse;